var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "originDialog" } },
    [
      _c(
        "el-dialog",
        {
          staticClass: "originDialog",
          attrs: {
            title: "默认单号来源设置",
            visible: _vm.originVisible,
            width: "710px",
            "before-close": _vm.closeOriginForm,
            center: "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.originVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "30px" } },
            [
              _c(
                "el-alert",
                {
                  staticClass: "alert systemColor",
                  attrs: {
                    title: "",
                    type: "info",
                    closable: false,
                    "show-icon": "",
                  },
                },
                [
                  _vm.form.waybillCode === "KS" &&
                  (_vm.form.wpCode === "SF" ||
                    _vm.form.wpCode === "EMS" ||
                    _vm.form.wpCode === "YZKDBG")
                    ? _c("span", [
                        _vm._v(
                          "因快手平台规则，面单账号授权后，自营物流商(如顺丰速运、EMS、邮政快递包裹)均需要再次输入客户编号才可正常打单"
                        ),
                      ])
                    : _c("span", [
                        _vm._v(
                          "设置默认单号来源后，打单时如果选择该电子面单模板，系统将默认用设置的单号源获取单号"
                        ),
                      ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-box-body" },
            [
              _c(
                "el-form",
                {
                  ref: "originForm",
                  attrs: {
                    model: _vm.form,
                    "label-width": "120px",
                    rules: _vm.rules,
                  },
                },
                [
                  _vm.form.waybillCode === "YTO" ||
                  _vm.form.waybillCode === "YTO_ZD"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "默认单号来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70%",
                                display: "inline-block",
                              },
                              attrs: { placeholder: "请选择单号来源" },
                              model: {
                                value: _vm.form.waybillKcodeOgigin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "waybillKcodeOgigin", $$v)
                                },
                                expression: "form.waybillKcodeOgigin",
                              },
                            },
                            _vm._l(_vm.ytoKcodeList, function (item, index) {
                              return _c("el-option", {
                                key: _vm.form.waybillCode + index,
                                attrs: {
                                  label: item.name
                                    ? item.code + "--" + item.name
                                    : item.code,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "systemColor",
                              staticStyle: {
                                "margin-left": "10px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.goEleAcount },
                            },
                            [_vm._v("添加电子面单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.waybillCode === "CN"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "默认单号来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70%",
                                display: "inline-block",
                              },
                              attrs: { placeholder: "请选择单号来源" },
                              model: {
                                value: _vm.form.waybillKcodeOgigin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "waybillKcodeOgigin", $$v)
                                },
                                expression: "form.waybillKcodeOgigin",
                              },
                            },
                            _vm._l(_vm.cnOriginList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  title:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "systemColor",
                              staticStyle: {
                                "margin-left": "10px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.goEleAcount },
                            },
                            [_vm._v("添加电子面单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.waybillCode === "PDD"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "默认单号来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70%",
                                display: "inline-block",
                              },
                              attrs: { placeholder: "请选择单号来源" },
                              model: {
                                value: _vm.form.waybillKcodeOgigin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "waybillKcodeOgigin", $$v)
                                },
                                expression: "form.waybillKcodeOgigin",
                              },
                            },
                            _vm._l(_vm.pddOriginList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  title:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "systemColor",
                              staticStyle: {
                                "margin-left": "10px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.goEleAcount },
                            },
                            [_vm._v("添加电子面单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.waybillCode === "LUBAN"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "默认单号来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70%",
                                display: "inline-block",
                              },
                              attrs: { placeholder: "请选择单号来源" },
                              model: {
                                value: _vm.form.waybillKcodeOgigin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "waybillKcodeOgigin", $$v)
                                },
                                expression: "form.waybillKcodeOgigin",
                              },
                            },
                            _vm._l(_vm.lubanOriginList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  title:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "systemColor",
                              staticStyle: {
                                "margin-left": "10px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.goEleAcount },
                            },
                            [_vm._v("添加电子面单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.waybillCode === "JD"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "默认单号来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70%",
                                display: "inline-block",
                              },
                              attrs: { placeholder: "请选择单号来源" },
                              model: {
                                value: _vm.form.waybillKcodeOgigin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "waybillKcodeOgigin", $$v)
                                },
                                expression: "form.waybillKcodeOgigin",
                              },
                            },
                            _vm._l(_vm.jdOriginList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  title:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "systemColor",
                              staticStyle: {
                                "margin-left": "10px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.goEleAcount },
                            },
                            [_vm._v("添加电子面单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.waybillCode === "KS"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "默认单号来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70%",
                                display: "inline-block",
                              },
                              attrs: { placeholder: "请选择单号来源" },
                              model: {
                                value: _vm.form.waybillKcodeOgigin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "waybillKcodeOgigin", $$v)
                                },
                                expression: "form.waybillKcodeOgigin",
                              },
                            },
                            _vm._l(_vm.ksOriginList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  title:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "systemColor",
                              staticStyle: {
                                "margin-left": "10px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.goEleAcount },
                            },
                            [_vm._v("添加电子面单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.waybillCode === "XIAOHS"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "默认单号来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70%",
                                display: "inline-block",
                              },
                              attrs: { placeholder: "请选择单号来源" },
                              model: {
                                value: _vm.form.waybillKcodeOgigin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "waybillKcodeOgigin", $$v)
                                },
                                expression: "form.waybillKcodeOgigin",
                              },
                            },
                            _vm._l(
                              _vm.xiaohsOriginList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      (item.mallName
                                        ? item.mallName + "-"
                                        : "") +
                                      (item.addressInfo || "") +
                                      `${
                                        _vm.cpCodeList.includes(item.cpCode)
                                          ? ""
                                          : `(余额: ${item.quantity || 0})`
                                      }`,
                                    title:
                                      (item.mallName
                                        ? item.mallName + "-"
                                        : "") +
                                      (item.addressInfo || "") +
                                      `${
                                        _vm.cpCodeList.includes(item.cpCode)
                                          ? ""
                                          : `(余额: ${item.quantity || 0})`
                                      }`,
                                    value: item.id,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "systemColor",
                              staticStyle: {
                                "margin-left": "10px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.goEleAcount },
                            },
                            [_vm._v("添加电子面单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.waybillCode === "YZ"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "默认单号来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70%",
                                display: "inline-block",
                              },
                              attrs: { placeholder: "请选择单号来源" },
                              model: {
                                value: _vm.form.waybillKcodeOgigin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "waybillKcodeOgigin", $$v)
                                },
                                expression: "form.waybillKcodeOgigin",
                              },
                            },
                            _vm._l(_vm.yzOriginList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  title:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "systemColor",
                              staticStyle: {
                                "margin-left": "10px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.goEleAcount },
                            },
                            [_vm._v("添加电子面单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.waybillCode === "WXSPH" ||
                  _vm.form.waybillCode === "WXGYS"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "默认单号来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70%",
                                display: "inline-block",
                              },
                              attrs: { placeholder: "请选择单号来源" },
                              model: {
                                value: _vm.form.waybillKcodeOgigin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "waybillKcodeOgigin", $$v)
                                },
                                expression: "form.waybillKcodeOgigin",
                              },
                            },
                            _vm._l(_vm.wxOriginList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  title:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : `(余额: ${item.quantity || 0})`
                                    }`,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "systemColor",
                              staticStyle: {
                                "margin-left": "10px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.goEleAcount },
                            },
                            [_vm._v("添加电子面单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.waybillCode === "DEWU"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "默认单号来源" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "70%",
                                display: "inline-block",
                              },
                              attrs: { placeholder: "请选择单号来源" },
                              model: {
                                value: _vm.form.waybillKcodeOgigin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "waybillKcodeOgigin", $$v)
                                },
                                expression: "form.waybillKcodeOgigin",
                              },
                            },
                            _vm._l(_vm.dewuOriginList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : ""
                                    }`,
                                  title:
                                    (item.mallName ? item.mallName + "-" : "") +
                                    (item.addressInfo || "") +
                                    `${
                                      _vm.cpCodeList.includes(item.cpCode)
                                        ? ""
                                        : ""
                                    }`,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "systemColor",
                              staticStyle: {
                                "margin-left": "10px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.goEleAcount },
                            },
                            [_vm._v("添加电子面单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.waybillCode === "KS" &&
                  (_vm.form.wpCode === "SF" ||
                    _vm.form.wpCode === "EMS" ||
                    _vm.form.wpCode === "YZKDBG")
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: "客户编号", prop: "settlementCode" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "70%",
                              display: "inline-block",
                            },
                            attrs: {
                              autocomplete: "off",
                              placeholder: "请输入客户编号",
                            },
                            model: {
                              value: _vm.form.settlementCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "settlementCode",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.settlementCode",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.waybillCode === "KS" && _vm.form.wpCode === "SF"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "独立客户编码",
                            prop: "independentSettlementCode",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "70%",
                              display: "inline-block",
                            },
                            attrs: {
                              autocomplete: "off",
                              placeholder: "请输入独立客户编码",
                            },
                            model: {
                              value: _vm.form.independentSettlementCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "independentSettlementCode",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.independentSettlementCode",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeOriginForm } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitOriginForm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }